import { createReducer } from "@reduxjs/toolkit";
import { STORAGE_RESET } from "../storeReset";
import { StoreState } from "../storeState";
import * as actions from "./actions";
import { IInformationTypeState } from "./types";

const initialState: IInformationTypeState = {
  availableState: StoreState.None,
  available: [],
  permissionsState: StoreState.None,
  permissionSet: null,
};

export const informationTypeReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(actions.availableFetchRequest, (state) => ({
      ...state,
      availableState: StoreState.Loading,
    }))
    .addCase(actions.availableFetchSuccess, (state, action) => ({
      ...state,
      availableState: StoreState.Loaded,
      available: action.payload,
    }))
    .addCase(actions.availableFetchError, (state) => ({
      ...state,
      availableState: StoreState.Error,
      available: [],
    }))
    .addCase(actions.permissionsFetchRequest, (state) => ({
      ...state,
      permissionsState: StoreState.Loading,
      permissionSet: null,
    }))
    .addCase(actions.permissionsFetchSuccess, (state, action) => ({
      ...state,
      permissionsState: StoreState.Loaded,
      permissionSet: action.payload,
    }))
    .addCase(actions.permissionsFetchError, (state) => ({
      ...state,
      permissionsState: StoreState.Error,
      permissionSet: null,
    }))
    .addCase(actions.permissionsReset, (state) => ({
      ...state,
      permissionsState: StoreState.None,
      permissionSet: null,
    }))
    .addCase(STORAGE_RESET, () => initialState)
);
